<template>
  <li
    class="note-template-list-item"
    data-testid="note-template-list-item">
    <span
      class="note-template-list-item__color"
      :style="{ backgroundColor: noteTemplate.color }" />
    <div class="note-template-list-item__body">
      <p class="note-template-list-item__departments">
        <span
          v-for="departmentName in departmentNames"
          :key="departmentName"
          class="note-template-list-item__department">
          {{ departmentName }}
        </span>
      </p>
      <p class="note-template-list-item__name">
        {{ noteTemplate.sortOrder | prettySortNo }} {{ noteTemplate.name }}
      </p>
      <p class="note-template-list-item__meta">
        {{ noteTemplate.updatedAt | prettyDateTime }}
        <span
          v-if="createdByName"
          class="ml-2">作成者 {{ createdByName }}</span>
      </p>
    </div>
    <div
      v-if="canEdit"
      class="note-template-list-item__actions">
      <IconButton
        icon="edit"
        color="grey"
        icon-color="l-blue"
        width="34"
        height="34"
        icon-size="20"
        data-testid="note-template-edit-button"
        @click="$emit('edit', noteTemplate)" />
      <IconButton
        icon="delete"
        color="grey"
        icon-color="l-blue"
        width="34"
        height="34"
        icon-size="20"
        class="ml-2"
        data-testid="note-template-delete-button"
        @click="$emit('delete', noteTemplate)" />
    </div>
  </li>
</template>

<script>
import IconButton from '@/components/parts/IconButton.vue'

export default {
  name: 'NoteTemplateListItem',
  components: {
    IconButton
  },
  props: {
    noteTemplate: {
      type: Object,
      required: true
    },
    canEdit: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    departmentNames() {
      if (this.noteTemplate.isAllDepartments) return ['すべてのグループ']
      // API から表示優先度の降順で返るため、そのまま表示する
      return (this.noteTemplate.departments || []).map(department => department.name)
    },
    createdByName() {
      // 作成者が削除されると createdBy は null になる
      return this.noteTemplate.createdBy?.name || null
    }
  }
}
</script>

<style lang="scss" scoped>
.note-template-list-item {
  display: flex;
  align-items: center;
  // grid アイテムの既定は min-width: auto で、1行にした本文の幅より縮まない。
  // 解除しないと狭い画面でカードが横にはみ出す
  min-width: 0;
  background-color: $white;
  border-radius: 8px;
  padding: 8px 12px;
  list-style: none;

  // カード左端の帯ではなく、テキスト全体の左に置く角丸のバー。
  // 仕様書では上下中央でカード高の4割ほどの長さ
  &__color {
    flex-shrink: 0;
    align-self: center;
    width: 9px;
    height: 40px;
    margin-right: 12px;
    border-radius: 3px;
  }

  // 本文が余白を埋めないと、カード中央に本文が寄って
  // 色バーと本文の間が空いてしまう
  &__body {
    flex: 1;
    min-width: 0;
  }

  // グループ名と日時・作成者は1行に収めて末尾を省略する。折り返すと
  // 日時と作成者名が分断されて読みにくくなるため
  &__departments,
  &__meta {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  &__departments {
    margin-bottom: 2px;
    font-size: $fs-s;
    color: $l-blue;
    font-weight: bold;
  }

  &__department {
    margin-right: 8px;
  }

  // テンプレート名だけは省略せず折り返す。
  // 長い英数字1語でもカードからはみ出さないよう折り返し位置を許可する
  &__name {
    margin-bottom: 2px;
    font-weight: bold;
    overflow-wrap: anywhere;
  }

  &__meta {
    margin-top: 2px;
    margin-bottom: 0;
    font-size: $fs-s;
    // $grey10 は罫線用（line02）で本文には薄すぎるため、本文用の text02 を使う
    color: $grey08;
  }

  &__actions {
    display: flex;
    flex-shrink: 0;
    margin-left: 8px;
  }
}
</style>
